<div class="content-wrap">
  <div class="slot-success">
    <img src="shared-assets/images/success-connct.svg" alt="" />
    <h2>Slot Connect Updated Successfully</h2>
  </div>
</div>
